var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForeignKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#66BCFF",
    fillRule: "evenodd",
    d: "M6.26319 5.9994L7.40517 6.77396L8.28822 6.57789L8.38645 7.43953L8.75628 7.69037L9.58879 7.46002L9.7388 8.35677L10.3083 8.74307L12 8.43399L11.6496 6.74347L7.59954 3.99646L7.73163 3.79953C8.19144 3.11404 8.01102 2.18587 7.32791 1.72255L5.19569 0.276341C4.5076 -0.19037 3.57116 -0.00834866 3.108 0.682142L1.512 3.06147C1.0525 3.74649 1.23234 4.67399 1.91455 5.13766L4.05072 6.58948C4.73983 7.05783 5.67857 6.87482 6.1413 6.18192L6.26319 5.9994ZM3.17959 3.63457C3.51564 3.86124 4.0332 3.68155 4.3356 3.23323C4.638 2.78491 4.61072 2.23772 4.27467 2.01106C3.93862 1.78439 3.42106 1.96408 3.11866 2.4124C2.81627 2.86072 2.84355 3.40791 3.17959 3.63457ZM0.8614 2.84486C0.8614 2.84486 0.468533 3.51562 0.60624 4.32515C0.743948 5.13467 1.49163 5.66646 1.49163 5.66646L4.11846 7.40199V10.7625L2.92065 12L1.71986 10.7625V10.2675L2.37531 9.641L1.71986 9.07579V8.62721L2.37531 8.0635L1.71986 7.43698V6.63922H1.5C0.671573 6.63922 0 5.96765 0 5.13922V2.53551C0 1.70709 0.671574 1.03551 1.5 1.03551H2.04691L0.8614 2.84486Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeignKey);
export default __webpack_public_path__ + "static/media/foreign-key.df6be33bd1e28fc42050cc079dd0d8ca.svg";
export { ForwardRef as ReactComponent };